import { LoadingButton } from "@mui/lab";
import { Card, Stack } from "@mui/material";
import { useContext } from "react";
import useGetApp from "src/hooks/useGetApp";
import useLocales from "src/hooks/useLocales";

import Context from "../context";
import useUpdateForceApi from "../services/useUpdateForceApi";
import FoceApiHeader from "./components/FoceApiHeader";

// ----------------------------------------------------------------------

export const ForceApiCard = () => {
	const { state } = useContext(Context);

	const { translate } = useLocales();

	const { updateApp, isLoading } = useUpdateForceApi();
	const app = useGetApp();

	return (
		<Card sx={{ p: 3, maxWidth: 800 }}>
			<FoceApiHeader />
			<Stack direction={"row"} justifyContent={"flex-end"} sx={{ mt: 2 }}>
				<LoadingButton
					variant='contained'
					color='primary'
					disabled={app?.forceSecureConnection === state.forceSecureConnection}
					loading={isLoading}
					onClick={() => updateApp(state.forceSecureConnection)}
				>
					{translate("Guardar")}
				</LoadingButton>
			</Stack>
		</Card>
	);
};

export default ForceApiCard;
